<template>
    <vx-card :title="formTitle" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <vs-input
                        label="Количество кликов для завершения теста"
                        v-model="form.clickLimit"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.clickLimit"
                        :danger-text="errors.clickLimit"
                    />
                </div>
            </div>
            <div class="vx-col w-1/4">
                <div class="ml-2 mt-1">
                    <label class="vs-input--label">Тип теста:</label>
                    <v-select
                        :options="form.testTypes"
                        :disabled="tid != 0"
                        label="description"
                        placeholder="Выберите тип теста..."
                        class="w-full"
                        v-model="form.testType"
                    >
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-5" style="display: inline-block">
                    <ul class="centerx mt-5">
                        <li>
                            <vs-checkbox :disabled="!isVariantsEmpty" v-model="form.image">Добавить изображение / видео </vs-checkbox>
                        </li>
                        <li>
                            <vs-checkbox :disabled="!isVariantsEmpty" v-model="form.title">Добавить заголовок </vs-checkbox>
                        </li>
                        <li v-if="!isTeaser()">
                            <vs-checkbox :disabled="!isVariantsEmpty" v-model="form.description">Добавить описание </vs-checkbox>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-3/4">
                <vs-table :data="variants" class="mt-5">
                    <template slot="header"> Задания теста: </template>
                    <template slot="thead">
                        <vs-th> Изображение / Видео </vs-th>
                        <vs-th> Заголовок </vs-th>
                        <vs-th v-if="!isTeaser()"> Описание </vs-th>
                        <vs-th> Действия </vs-th>
                    </template>
                    <template slot-scope="{ data }">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td class="vs-lg-3">
                                <img
                                    class="centerInner image-preview"
                                    v-if="tr.image && tr.image.width1"
                                    :width="thumbWidth(tr)"
                                    :src="tr.image.data1"
                                />
                                <video
                                    controls
                                    v-if="tr.video && tr.video.url"
                                    class="edit-native-video-player"
                                    width="250"
                                    :src="tr.video.url"
                                ></video>
                            </vs-td>
                            <vs-td style="text-align: left">{{ tr.title }}</vs-td>
                            <vs-td v-if="!isTeaser()" style="text-align: left">{{ tr.description }}</vs-td>
                            <vs-td>
                                <!-- <div class="inline-block cursor-pointer" v-if="!tr.isDefault">
                                    <feather-icon @click="editVariant(tr)" icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7" />
                                </div> -->
                                <div class="inline-block cursor-pointer" v-if="!tr.isDefault">
                                    <feather-icon
                                        @click="deleteVariant(tr)"
                                        icon="XCircleIcon"
                                        class="inline-block mr-2 text-danger"
                                        svgClasses="w-7 h-7"
                                    />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <div class="vx-col w-1/4"></div>
        </div>

        <!-- add variant -->
        <vx-card title="Добавить задание">
            <div class="vx-row mt-3 mb-2" v-if="form.title">
                <div class="vx-col w-full">
                    <label class="required bld">Заголовок:</label>
                    <div class="mt-1">
                        <vs-input
                            v-model="modal.form.title"
                            class="mt-1 w-full"
                            :danger="!!modal.errors.title"
                            :danger-text="modal.errors.title"
                            :maxlength="maxLength"
                        />
                    </div>
                </div>
            </div>
            <div v-if="form.title" style="color: red; font-size: 10px">
                {{ 'напечатано ' + (modal.form.title ? modal.form.title.length : 0) + ' символов, лимит ' + maxLength + ' символов' }}
            </div>

            <div class="vx-row mt-5 mb-2" v-if="form.description && !isTeaser()">
                <div class="vx-col w-full">
                    <label class="required bld">Описание:</label>
                    <div class="mt-1">
                        <vs-input
                            v-model="modal.form.description"
                            class="mt-1 w-full"
                            :danger="!!modal.errors.description"
                            :danger-text="modal.errors.description"
                            maxlength="100"
                        />
                    </div>
                </div>
            </div>
            <div v-if="form.description && !isTeaser()" style="color: red; font-size: 10px">
                {{ 'напечатано ' + (modal.form.description ? modal.form.description.length : 0) + ' символов, лимит 100 символов' }}
            </div>

            <div class="vx-row mt-5 mb-2" v-if="form.image">
                <div class="vx-col w-full">
                    <label class="required bld">Загрузить изображение / видео:</label>
                    <div class="required">
                        <v-select
                            :clearable="false"
                            :options="this.mimeTypes"
                            label="name"
                            placeholder="Выберите тип"
                            class="lg-2 inline-block"
                            v-model="mimeType"
                        >
                        </v-select>
                    </div>

                    <div v-if="this.mimeType.value == 'image'">
                        <div class="vx-col w-1/2 mt-6 mb-6">
                            <vs-checkbox class="mt-6" icon="check" color="rgb(38, 187, 174)" v-model="image.checkProportions">
                                Показ при нужной пропорции
                            </vs-checkbox>
                        </div>

                        <load-image
                            v-if="!image.checkProportions"
                            ref="loadImage"
                            :uploaded="image"
                            :campaignId="ad.campaignId"
                            @selectImage="onSelectImage($event)"
                        >
                        </load-image>

                        <load-images
                            v-if="image.checkProportions"
                            ref="loadImages"
                            :uploaded="image"
                            :campaignId="ad.campaignId"
                            @selectImages="onSelectImage($event)"
                        >
                        </load-images>
                    </div>
                    <div v-if="this.mimeType.value == 'video'">
                        <load-video ref="loadVideo" :uploaded="video" @selectVideo="onSelectVideo($event)"></load-video>
                    </div>
                </div>
            </div>
            <div class="mt-2">
                <vs-button color="primary" @click="saveVariant()" type="filled"> Добавить </vs-button>
                <vs-button class="mt-2 ml-5" color="warning" type="border" @click="addVariant()"> Очистить </vs-button>
            </div>
        </vx-card>
        <!-- -->

        <vs-button class="mt-5 ml-5" color="success" @click="saveAbTest()" type="filled" :disabled="isVariantsEmpty || saving">
            Сохранить А/Б тест
        </vs-button>
        <vs-button class="ml-3 mt-5" color="warning" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import axios from 'axios';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

import LoadImage from '../ads/LoadImage';
import LoadImages from '../ads/LoadImages';
import LoadVideo from '../ads/LoadVideo';
import AD_TYPES from 'config/adTypes';

export default {
    name: 'abtestad-createedit',
    props: ['adid', 'tid'],
    data() {
        return {
            variants: [],
            ad: undefined,
            image: undefined,
            video: undefined,
            new_ad: false,
            sspTypeIds: undefined,
            saving: false,
            form: {
                clickLimit: 2000,
                title: false,
                description: false,
                image: false,
                testTypes: [],
                testType: undefined
            },
            errors: {
                clickLimit: ''
            },
            modal: {
                form: {
                    title: '',
                    description: '',
                    image: undefined,
                    video: undefined,
                    imageData: '',
                    cropdata1: '',
                    cropdata2: '',
                    uri1: '',
                    uri2: '',
                    editedindex: null
                },
                errors: {
                    title: '',
                    description: '',
                    image: ''
                }
            },
            mimeTypes: [
                {
                    name: 'Изображение',
                    value: 'image'
                },
                {
                    name: 'Видео',
                    value: 'video'
                }
            ],
            mimeType: { name: 'Изображение', value: 'image' }
        };
    },

    components: {
        vSelect,
        SweetModal,
        SweetModalTab,
        VueCropper,
        LoadImage,
        LoadImages,
        LoadVideo
    },

    methods: {
        isTeaser() {
            return this.ad && this.ad.adTypeId && this.ad.adTypeId == AD_TYPES.native;
        },

        loadAbTest() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .get('abtestad/' + this.tid)
                .then((res) => {
                    let abt = res.data;

                    this.form.clickLimit = abt.clickLimit;

                    this.variants = [];
                    let image;
                    let video;

                    this.form.image = false;
                    this.form.title = false;
                    this.form.description = false;
                    this.form.testType = this.form.testTypes.find((t) => t.id == abt.abTestType);

                    abt.variants.forEach((c) => {
                        image = {};
                        if (c.image && c.image.url1 && c.image.url2) {
                            image.id = 0;
                            image.name = '0f1afea9-5bd9-4e21-87ee-4af98cc4d949.jpg';
                            image.type = 'image/jpeg';
                            image.data1 = c.image.url1;
                            image.width1 = c.image.width1;
                            image.height1 = c.image.height1;
                            image.data2 = c.image.url2;
                            image.width2 = c.image.width2;
                            image.height2 = c.image.height2;
                            this.form.image = true;
                        }

                        video = {};
                        if (c.video && c.video.url) {
                            video.url = c.video.url;
                            video.width = c.video.width;
                            video.height = c.video.height;
                        }

                        if (c.title) this.form.title = true;
                        if (c.description) this.form.description = true;

                        if (!c.isDefault) {
                            this.variants.push({
                                id: c.id,
                                isDefault: c.isDefault,
                                title: c.title,
                                description: c.description,
                                image: image,
                                video: video
                            });
                        }
                    });
                })
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadData() {
            this.axios
                .get('abtestad/dicts')
                .then((res) => {
                    this.form.testTypes = res.data.abTestTypes;
                    if (this.tid == 0) {
                        this.form.testType = this.form.testTypes.find((t) => t.id == res.data.abTestTypeDefault);
                    } else {
                        this.loadAbTest();
                    }
                })
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных словарей.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadAdAndImages() {
            this.axios
                .all([this.axios.get('ads/' + this.adid + '/images'), this.axios.get('ads/' + this.adid)])
                .then(
                    axios.spread((response, ad) => {
                        const images = response.data;
                        if (images) {
                            this.image = images.find((i) => i.imageTypeId == 1);
                            this.image ||= {};
                        }
                        this.ad = ad.data;
                        this.sspTypeIds = ad.data.sspTypeIds;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },

        saveAbTest() {
            if (this.variants.length == 0) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Необходимо указать задания!',
                    color: 'danger'
                });
            }

            this.saving = true;

            let variantsWithoutSrc = [];
            this.variants.forEach((v) => {
                let image = null;
                if (v.image && v.image.data1) {
                    image = {
                        id: v.image.id,
                        data1: v.image.data1,
                        data2: v.image.data2,
                        height1: v.image.height1,
                        height2: v.image.height2,
                        width1: v.image.width1,
                        width2: v.image.width2,
                        name: v.image.name,
                        type: v.image.type
                    };
                }

                let video = null;
                if (v.video && v.video.data) {
                    video = {
                        data: v.video.data,
                        name: v.video.name,
                        size: v.video.size,
                        url: v.video.url
                    };
                }

                variantsWithoutSrc.push({
                    id: v.id,
                    title: v.title,
                    description: v.description,
                    image: image,
                    video: video
                });
            });

            if (this.tid == 0) {
                // При создании нового теста.
                const params = {
                    adId: this.adid,
                    clickLimit: this.form.clickLimit,
                    isNewAd: this.new_ad,
                    abTestType: this.form.testType.id,
                    variants: variantsWithoutSrc
                };

                this.$axios({
                    method: 'POST',
                    url: 'abtestad',
                    params: params,
                    errors: this.errors,
                    success: (response) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.$vs.notify({
                            title: 'Успешно добавлено',
                            text: 'Тест успешно добавлен',
                            color: 'success'
                        });

                        // if (this.new_ad) {
                        //     this.$store.dispatch('SET_TEST_ID_FOR_RELOAD_FORM', response.id);
                        // }

                        this.$router.push({ name: 'abtestad', params: { id: this.adid } });
                    },
                    catch: (err) => {
                        this.saving = false;
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        if (err.request.status == 422 && err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: 'Внимание!',
                                text: error,
                                color: 'danger'
                            });
                        }

                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: 'Ошибка при добавлении теста!',
                            color: 'danger'
                        });
                    }
                });
            } else {
                // При редактировании теста.
                const params = {
                    testId: this.tid,
                    adId: this.adid,
                    clickLimit: this.form.clickLimit,
                    isNewAd: this.new_ad,
                    abTestType: this.form.testType.id,
                    variants: variantsWithoutSrc
                };

                this.$axios({
                    method: 'PUT',
                    url: 'abtestad/' + this.tid,
                    params: params,
                    errors: this.errors,
                    success: (response) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.$vs.notify({
                            title: 'Успешно обновлен',
                            text: 'Тест успешно обновлен',
                            color: 'success'
                        });
                        this.$router.push({ name: 'abtestad', params: { id: this.adid } });
                    },
                    catch: (err) => {
                        this.saving = false;
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        if (err.request.status == 422 && err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: 'Внимание!',
                                text: error,
                                color: 'danger'
                            });
                        }

                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: 'Ошибка при обновлении теста!',
                            color: 'danger'
                        });
                    }
                });
            }
        },

        thumbWidth(ad) {
            if (ad.image) {
                const image = ad.image;
                return image.width1 / 3;
            }
        },

        cancelEdit() {
            this.$router.push({
                name: 'abtestad',
                params: {
                    id: this.adid
                }
            });
        },

        addVariant() {
            this.modal.form.imageData = '';
            this.modal.form.uri1 = '';
            this.modal.form.uri2 = '';
            this.modal.form.title = '';
            this.modal.form.description = '';
            this.modal.errors.image = '';
            this.modal.errors.title = '';
            this.modal.errors.description = '';
            this.modal.form.editedindex = null;

            if (this.$refs.loadImage) this.$refs.loadImage.reset();
            if (this.$refs.loadImages) this.$refs.loadImages.reset();
            if (this.$refs.loadVideo) this.$refs.loadVideo.reset();
        },
        saveVariant() {
            var err = false;

            // Проверка заполнены ли поля.

            if (!this.form.image && !this.form.title && !this.form.description) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Необходимо выбрать поля для теста (изображение, заголовок или описание)',
                    color: 'danger'
                });
            }

            // В случаe если редактируется вариант изображение можно не загружать даже если оно требуется.
            // Требуется, но не загружено.
            if (this.form.image && !this.modal.form.imageData && !this.modal.form.videoData)
                if (this.modal.form.editedindex == null) {
                    this.modal.errors.image = 'Необходимо загрузить изображение или видео';
                    err = true;
                } else {
                    this.modal.errors.image = '';
                }

            if (this.form.title && !this.modal.form.title) {
                this.modal.errors.title = 'Необходимо заполнить заголовок';
                err = true;
            } else if (this.form.title && this.modal.form.title && this.modal.form.title.length > this.maxLength) {
                this.modal.errors.title = `Заголовок объявления должен быть не более ${this.maxLength} символов`;
                err = true;
            } else {
                this.modal.errors.title = '';
            }

            if (this.form.description && !this.modal.form.description) {
                this.modal.errors.description = 'Необходимо заполнить описание';
                err = true;
            } else if (this.form.description && this.modal.form.description && this.modal.form.description.length > 100) {
                this.modal.errors.description = 'Описание объявления должен быть не более 100 символов';
                err = true;
            } else {
                this.modal.errors.description = '';
            }

            if (err) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Неправильно заполнены поля',
                    color: 'danger'
                });
            }
            if (this.form.image && this.modal.form.imageData) {
                const imageData = { ...this.modal.form.imageData };
                this.saveToVariants(this.modal.form.title, this.modal.form.description, imageData, null, this.modal.form.editedindex);
            } else if (this.form.image && this.modal.form.videoData) {
                const videoData = { ...this.modal.form.videoData };
                this.saveToVariants(this.modal.form.title, this.modal.form.description, null, videoData, this.modal.form.editedindex);
            } else {
                this.saveToVariants(this.modal.form.title, this.modal.form.description, null, null, this.modal.form.editedindex);
            }

            this.addVariant();
            this.modal.form.videoData = undefined;
        },

        saveToVariants(title, description, image, video, index) {
            if (index != null && index >= 0) {
                if (image == null) image = this.variants[index].image;
                var id = this.variants[index].id;
                Vue.set(this.variants, index, {
                    id: id,
                    title: title,
                    description: description,
                    image: image,
                    video: video
                });
            } else {
                this.variants.push({
                    title: title,
                    description: description,
                    image: image,
                    video: video
                });
            }
        },

        editVariant(variant) {
            debugger;
            if (variant.image && variant.image.data1) {
                this.mimeType = this.mimeTypes.find((m) => m.value == 'image');
                if (variant.image.src) {
                    // Новый вариант.
                    this.modal.form.imageData = variant.image;
                    this.modal.form.uri1 = '';
                    this.modal.form.uri2 = '';
                } else {
                    // Старый вариант.
                    this.modal.form.imageData = '';
                    this.modal.form.cropdata1 = '';
                    this.modal.form.cropdata2 = '';
                    this.modal.form.uri1 = variant.image.data1;
                    this.modal.form.uri2 = variant.image.data2;
                    this.modal.form.imageData = variant.image;
                    this.image = variant.image;
                }
            }

            if (variant.video && variant.video.url) {
                this.mimeType = this.mimeTypes.find((m) => m.value == 'video');
                this.video = variant.video;
            }

            this.modal.form.title = variant.title;
            this.modal.form.description = variant.description;
            this.modal.errors.image = '';
            this.modal.errors.title = '';
            this.modal.errors.description = '';
            this.modal.form.editedindex = this.variants.indexOf(variant);

            if (!this.form.image && !this.form.title && !this.form.description) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Необходимо выбрать поля для теста (изображение, заголовок или описание)',
                    color: 'danger'
                });
            }
        },

        deleteVariant(variant) {
            let index = this.variants.indexOf(variant);
            this.variants.splice(index, 1);
        },

        // Upload images.
        onSelectImage(image) {
            this.modal.form.imageData = image;
        },
        // Upload video
        onSelectVideo(video) {
            this.modal.form.videoData = video;
        }
    },

    computed: {
        maxLength() {
            return 120;
        },
        formTitle() {
            return this.tid == 0 ? 'Добавление A/Б теста' : 'Редактирование A/Б теста';
        },
        isVariantsEmpty() {
            return this.variants ? this.variants.length == 0 : true;
        }
    },

    watch: {},

    mounted() {
        this.new_ad = this.$store.getters.ABTEST_FOR_NEW_AD;

        this.loadData();
        this.loadAdAndImages();
    }
};
</script>

<style scoped lang="scss">
.select-error > div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}

.centerx li {
    display: inline-block !important;
    padding-right: 50px !important;
}

.bld {
    font-weight: bold;
}

.centerInner {
    display: inline-block !important;
}

.errmessage {
    display: block !important;
    color: red;
    font-size: 0.65rem;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    font-weight: 400;
}

table {
    border: 1px solid #ccc !important;
    border-spacing: 0px;
    border-collapse: collapse;
    text-align: center !important;

    th {
        border: 1px solid #ccc !important;
        text-align: left !important;
        font-size: 15px !important;
        padding-left: 70px !important;
        margin: 0 auto;
    }

    tr {
        border: 1px solid #ccc !important;
    }

    td {
        border: 1px solid #ccc !important;
        text-align: center;
        font-weight: normal;
        font-size: 12px !important;
        height: 4px !important;
        padding: 0px !important;
        padding-left: 5px !important;
        margin: 0px !important;
    }
}

.maxlength-text {
    color: red;
    font-size: 10px;
}
</style>
